// extracted by mini-css-extract-plugin
export var container = "_he-0";
export var content = "_he-3";
export var customerTitle = "_he-4";
export var empty = "_he-5";
export var gray = "_he-6";
export var header = "_he-7";
export var info = "_he-8";
export var loading = "_he-2";
export var loadingCard = "_he-9";
export var oneLine = "_he-a";
export var personName = "_he-e";
export var pillContainer = "_he-b";
export var selected = "_he-1";
export var text = "_he-c";
export var twoLines = "_he-d";
export var unread = "_he-f";
export var unreadIndicator = "_he-g";